<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col w-full mb-base">
        <vs-card title="">
          <b-row>
            <b-col cols="12" style=" padding-right: 20px">
              <b-row align-h="start" align-v="end">
                <b-col cols="2" class="align-self-start">
                  <b-form-group label="Raporlar" label-for="item-name">
                    <v-select
                      v-model="raporListSecilen"
                      :options="raporList"
                      label="baslik"
                      style=""
                      @input="finansListele()"
                    >
                    </v-select
                  ></b-form-group>
                </b-col>

                <b-col cols="2" class="align-self-start">
                  <b-form-group label="Pazaryerleri" label-for="item-name">
                    <v-select
                      v-model="pazaryeriSecilen"
                      :options="tabList"
                      label="name"
                      style=""
                      @input="finansListele()"
                    >
                    </v-select
                  ></b-form-group>
                </b-col>
                <b-col cols="4" class="align-self-start">
                  <b-row class="mb-2">
                    <b-col cols="6">
                      <b-form-group label="Başlangıç Tarihi" label-for="item-name">
                        <b-form-datepicker
                          bottom
                          v-model="datepickerbaslangic"
                          placeholder="-"
                          size="md"
                          local="tr-TR"
                          today-variant="danger"
                          :start-weekday="weekday"
                          :date-format-options="{
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric'
                          }"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group label="Bitiş Tarihi" label-for="item-name">
                        <b-form-datepicker
                          bottom
                          v-model="datepickerbitis"
                          placeholder="-"
                          size="md"
                          local="tr-TR"
                          today-variant="danger"
                          :start-weekday="weekday"
                          :date-format-options="{
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric'
                          }"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <div
                    v-if="isCiroSiparisReportSelected()"
                    class="quick-date-range-buttons"
                  >
                    <vs-button
                      v-for="range in quickDateRanges"
                      :key="range.value"
                      size="small"
                      style="border-radius: 5px"
                      type="border"
                      @click="setQuickDateRange(range.value)"
                      >{{ range.label }}</vs-button
                    >
                  </div>
                </b-col>
                <b-col cols="2" class="align-self-start">
                  <b-form-group label="Arama" label-for="item-name">
                    <b-form-input
                      v-model="aranan"
                      id="smallInput"
                      placeholder="Aranan"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="auto" class="align-self-start"
                  ><vs-button
                    style="border-radius: 5px"
                    color="success"
                    @click="finansmanCek(1)"
                    id="button-with-loading"
                    class="w-full vs-con-loading__container"
                    type="gradient"
                    >Bilgileri Çek</vs-button
                  >
                </b-col>
                <b-col cols="12" md="auto" class="align-self-start"
                  ><vs-button
                    style="border-radius: 5px"
                    color="danger"
                    id="button-with-loading-list"
                    class="vs-con-loading__container"
                    :disabled="finansListeLoading"
                    @click="finansListele()"
                    type="gradient"
                    >Listele</vs-button
                  >
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <div class="demo-alignment"></div>
        </vs-card>
        <div v-if="showCiroSiparisTables">
          <b-row>
            <b-col cols="12" lg="6">
              <vs-card title="Pazaryeri Ciro">
                <ag-grid-vue
                  style="width: 100%; height: 400px; margin-top: 25px"
                  class="ag-theme-alpine"
                  :defaultColDef="defaultColDef"
                  :columnDefs="ciroColumnDefs"
                  :rowData="ciroRowData"
                  :localeText="localeText"
                  @first-data-rendered="onFirstDataRendered"
                >
                </ag-grid-vue>
              </vs-card>
            </b-col>
            <b-col cols="12" lg="6">
              <vs-card title="Pazaryeri Ciro Dağılımı">
                <div class="ciro-chart-wrapper">
                  <chartjs-component-doughnut-chart
                    :height="250"
                    :data="ciroOnlyChartData"
                    :chartData="ciroOnlyChartData"
                    :options="ciroOnlyChartOptions"
                  ></chartjs-component-doughnut-chart>
                </div>
              </vs-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6">
              <vs-card title="Pazaryeri Sipariş">
                <ag-grid-vue
                  style="width: 100%; height: 400px; margin-top: 25px"
                  class="ag-theme-alpine"
                  :defaultColDef="defaultColDef"
                  :columnDefs="siparisColumnDefs"
                  :rowData="siparisRowData"
                  :localeText="localeText"
                  @first-data-rendered="onFirstDataRendered"
                >
                </ag-grid-vue>
              </vs-card>
            </b-col>
            <b-col cols="12" lg="6">
              <vs-card title="Pazaryeri Sipariş Dağılımı">
                <div class="ciro-chart-wrapper">
                  <chartjs-component-doughnut-chart
                    :height="250"
                    :data="siparisOnlyChartData"
                    :chartData="siparisOnlyChartData"
                    :options="siparisOnlyChartOptions"
                  ></chartjs-component-doughnut-chart>
                </div>
              </vs-card>
            </b-col>
          </b-row>
        </div>
        <b-row v-else>
          <b-col cols="12">
            <vs-card>
              <ag-grid-vue
                style="width: 100%; height: 400px; margin-top: 25px"
                class="ag-theme-alpine"
                :defaultColDef="defaultColDef"
                :columnDefs="columnDefs"
                :rowData="rowdata"
                :localeText="localeText"
                :excelStyles="excelStyles"
                @grid-ready="onGridReady"
                @first-data-rendered="onFirstDataRendered"
              >
              </ag-grid-vue>
            </vs-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import state from "../../store/state";
import Store from "../../store/store";
import { tr } from "vuejs-datepicker/dist/locale/";
import { BFormDatepicker } from "bootstrap-vue";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import ChartjsComponentDoughnutChart from "../charts-components/ChartjsComponentDoughnutChart.vue";
export default {
  data() {
    return {
      aranan: "",
      datepickerbitis: "",
      datepickerbaslangic: "",
      weekday: 1,
      raporListSecilen: "",
      pazaryeriSecilen: "",
      raporList: [],
      tabList: [],
      quickDateRanges: [
        { label: "Bugün", value: "today" },
        { label: "Bu Hafta", value: "thisWeek" },
        { label: "Bu Ay", value: "thisMonth" },
        { label: "Bu Yıl", value: "thisYear" },
        { label: "Dün", value: "yesterday" },
        { label: "Geçen Hafta", value: "lastWeek" },
        { label: "Geçen Ay", value: "lastMonth" },
        { label: "Geçen Yıl", value: "lastYear" }
      ],
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      excelStyles: [
        {
          id: "excelText",
          dataType: "String"
        }
      ],
      columnDefs: [],
      finansListeLoading: false,
      ciroColumnDefs: [
        { headerName: "Pazaryeri", field: "program", filter: "agSetColumnFilter" },
        {
          headerName: "Ciro",
          field: "Ciro",
          filter: "agNumberColumnFilter",
          valueFormatter: params => this.formatCurrency(params.value)
        }
      ],
      siparisColumnDefs: [
        { headerName: "Pazaryeri", field: "program", filter: "agSetColumnFilter" },
        {
          headerName: "Sipariş Adedi",
          field: "Adet",
          filter: "agNumberColumnFilter",
          valueFormatter: params => this.formatNumber(params.value)
        }
      ],
      localeText: null,
      rowdata: null,
      ciroRowData: [],
      siparisRowData: [],
      showCiroSiparisTables: false,
      currentTabMarketplace: "",
      ciroOnlyChartData: {
        labels: [],
        datasets: []
      },
      siparisOnlyChartData: {
        labels: [],
        datasets: []
      },
      ciroOnlyChartOptions: {
        hover: { mode: null },
        legend: {
          position: "bottom"
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              const label = data.labels[tooltipItem.index] || "";
              const dataset = data.datasets[0] || {};
              const value = dataset.data[tooltipItem.index] || 0;
              const formattedValue = new Intl.NumberFormat("tr-TR", {
                style: "currency",
                currency: "TRY"
              }).format(value);
              return label + ": " + formattedValue;
            }
          }
        },
        title: {
          display: true,
          text: "Pazaryerlerine gore ciro dagilimi"
        }
      },
      siparisOnlyChartOptions: {
        hover: { mode: null },
        legend: {
          position: "bottom"
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              const label = data.labels[tooltipItem.index] || "";
              const dataset = data.datasets[0] || {};
              const value = dataset.data[tooltipItem.index] || 0;
              const formattedValue =
                new Intl.NumberFormat("tr-TR").format(value) + " adet";
              return label + ": " + formattedValue;
            }
          }
        },
        title: {
          display: true,
          text: "Pazaryerlerine gore siparis dagilimi"
        }
      },
      colorPack: [
        "#7367F0",
        "#28C76F",
        "#EA5455",
        "#FF9F43",
        "#00CFE8",
        "#1E1E1E",
        "#9B59B6",
        "#2ECC71",
        "#3498DB",
        "#E67E22",
        "#E74C3C",
        "#34495E"
      ],
      marketplaceColorMap: {
        shopify: "#28A745",
        lcw: "#003B73",
        lcwaikiki: "#003B73",
        trendyol: "#FF7A00",
        boyner: "#E30613",
        beymen: "#111111",
        hepsiburada: "#00AEEF",
        hipicon: "#7B2CBF",
        milagron: "#C6D300"
      }
    };
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    finansmanCek(sayfasayisi) {
      var vm = this;
      var vs = this.$vs;
      vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45
      });

      const soap = require("soap");
      const url = state.sistemAddress;
      if (
        vm.pazaryeriSecilen.name == "" ||
        typeof vm.pazaryeriSecilen.name == "undefined"
      ) {
        vs.notify({
          title: "Trendyol Finansman",
          text: "Pazaryeri seçimi yapınız",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        const args = {
          pazaryeri: vm.pazaryeriSecilen.name
        };
        soap.createClient(url, function(err, client) {
          client.FinansVeri(args, function(err, result) {
            try {
              vm.veriler = JSON.parse(result.FinansVeriResult);
              if (vm.veriler.response == "Ok") {
                vs.loading.close("#button-with-loading > .con-vs-loading");
              } else {
                vs.loading.close("#button-with-loading > .con-vs-loading");
                vs.notify({
                  title: "Trendyol Finansman",
                  text: "Veriler Çekilemedi",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center"
                });
              }
            } catch (error) {
              vs.loading.close("#button-with-loading > .con-vs-loading");
              vs.notify({
                title: "Trendyol Finansman",
                text: "Veriler Çekilemedi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
            }
          });
        });
      }
    },
    raporListesi() {
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId
      };
      soap.createClient(url, function(err, client) {
        client.raporBaslik(args, function(err, result) {
          try {
            vm.veriler = JSON.parse(result.raporBaslikResult);
            vm.raporList = vm.veriler;
            console.log(vm.raporList);
          } catch (error) {}
        });
      });
    },
    sizeToFit() {
      console.log(this.gridApi);
      this.gridApi.sizeColumnsToFit();
    },
    setQuickDateRange(range) {
      const ranges = {
        today: [moment(), moment()],
        yesterday: [
          moment().subtract(1, "day"),
          moment().subtract(1, "day")
        ],
        thisWeek: [moment().startOf("isoWeek"), moment().endOf("isoWeek")],
        lastWeek: [
          moment().subtract(1, "week").startOf("isoWeek"),
          moment().subtract(1, "week").endOf("isoWeek")
        ],
        thisMonth: [moment().startOf("month"), moment().endOf("month")],
        lastMonth: [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month")
        ],
        thisYear: [moment().startOf("year"), moment().endOf("year")],
        lastYear: [
          moment().subtract(1, "year").startOf("year"),
          moment().subtract(1, "year").endOf("year")
        ]
      };

      const selectedRange = ranges[range];
      if (!selectedRange) return;

      this.datepickerbaslangic = selectedRange[0].format("YYYY-MM-DD");
      this.datepickerbitis = selectedRange[1].format("YYYY-MM-DD");
    },

    finansListele() {
      var vm = this;
      var vs = this.$vs;
      if (vm.finansListeLoading) {
        return;
      }

      vm.finansListeLoading = true;
      vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading-list",
        scale: 0.45
      });

      vm.finansList = [];
      vm.rowdata = [];
      vm.ciroRowData = [];
      vm.siparisRowData = [];
      vm.showCiroSiparisTables = false;
      vm.columnDefs = [];
      vm.clearCiroSiparisCharts();
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        aranan: vm.aranan,
        ilkTarih: vm.datepickerbaslangic,
        sonTarih: vm.datepickerbitis,
        baslik: vm.raporListSecilen.baslik,
        program: vm.pazaryeriSecilen.name,
        userId: Store.state.UserId
      };
      console.log(args);
      soap.createClient(url, function(err, client) {
        if (err) {
          vm.closeFinansListeLoading();
          return;
        }

        client.raporlar(args, function(err, result) {
          try {
            if (err) {
              vm.closeFinansListeLoading();
              return;
            }

            vm.veriler = JSON.parse(result.raporlarResult);

            let list = vm.veriler;
            if (!list || list.length == 0) {
              vm.rowdata = [];
              vm.ciroRowData = [];
              vm.siparisRowData = [];
              vm.closeFinansListeLoading();
              return;
            }

            if (vm.isCiroSiparisReportSelected() && vm.isCiroSiparisReportData(list)) {
              vm.finansList = list;
              vm.rowdata = [];
              vm.showCiroSiparisTables = true;
              vm.ciroRowData = vm.createSortedReportRows(list, "Ciro");
              vm.siparisRowData = vm.createSortedReportRows(list, "Adet");
              vm.createCiroSiparisCharts(list);
              vm.closeFinansListeLoading();
              return;
            }

            const textColumns = [
              "Stok kodu",
              "Sipariş No",
            ];

            let columnList = Object.keys(list[0]);
            columnList.forEach(val => {
              const columnDef = { field: val, filter: "agSetColumnFilter" };

              if (textColumns.includes(val)) {
                columnDef.cellClass = "excelText";
              }

              vm.columnDefs.push(columnDef);
            });

            vm.finansList = vm.veriler;
            vm.rowdata = list;
            //  vm.sizeToFit();
            // vm.eslesenStokListesi=vm.veriler
          } catch (error) {
            console.error(error);
          }

          vm.closeFinansListeLoading();
        });
      });
    },
    closeFinansListeLoading() {
      this.finansListeLoading = false;
      this.$vs.loading.close("#button-with-loading-list > .con-vs-loading");
    },
    clearCiroSiparisCharts() {
      this.ciroOnlyChartData = {
        labels: [],
        datasets: []
      };
      this.siparisOnlyChartData = {
        labels: [],
        datasets: []
      };
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY"
      }).format(Number(value) || 0);
    },
    formatNumber(value) {
      return new Intl.NumberFormat("tr-TR").format(Number(value) || 0);
    },
    isCiroSiparisReportData(list) {
      return (
        list &&
        list.length > 0 &&
        Object.prototype.hasOwnProperty.call(list[0], "program") &&
        Object.prototype.hasOwnProperty.call(list[0], "Ciro") &&
        Object.prototype.hasOwnProperty.call(list[0], "Adet")
      );
    },
    isCiroSiparisReportSelected() {
      const selectedReport = this.raporListSecilen || {};
      const reportValues = [
        selectedReport.baslik,
        selectedReport.value,
        selectedReport.kod,
        selectedReport.id,
        selectedReport.name
      ];

      return reportValues.some(value => {
        const reportValue = String(value || "").toLowerCase();
        return (
          reportValue == "rp-ciro-sipariş" ||
          reportValue == "rp-ciro-siparis"
        );
      });
    },
    createSortedReportRows(list, valueField) {
      return list
        .map(item => ({
          program: item.program,
          Ciro: Number(item.Ciro) || 0,
          Adet: Number(item.Adet) || 0
        }))
        .sort((first, second) => second[valueField] - first[valueField]);
    },
    normalizeMarketplaceName(value) {
      return String(value || "")
        .toLocaleLowerCase("tr-TR")
        .replace(/ğ/g, "g")
        .replace(/ü/g, "u")
        .replace(/ş/g, "s")
        .replace(/ı/g, "i")
        .replace(/ö/g, "o")
        .replace(/ç/g, "c")
        .replace(/[^a-z0-9]/g, "");
    },
    getMarketplaceColor(program, index) {
      const normalizedProgram = this.normalizeMarketplaceName(program);
      const colorKey = Object.keys(this.marketplaceColorMap).find(key =>
        normalizedProgram.includes(key)
      );

      if (colorKey) {
        return this.marketplaceColorMap[colorKey];
      }

      return this.colorPack[index % this.colorPack.length];
    },
    createReportChartData(list, valueField, datasetLabel) {
      const labels = [];
      const data = [];
      const backgroundColor = [];

      const chartList = list.filter(item => {
        return this.normalizeMarketplaceName(item.program) != "geneltoplam";
      });

      chartList.forEach((item, index) => {
        labels.push(item.program);
        data.push(Number(item[valueField]) || 0);
        backgroundColor.push(this.getMarketplaceColor(item.program, index));
      });

      return {
        labels: labels,
        datasets: [
          {
            label: datasetLabel,
            data: data,
            backgroundColor: backgroundColor,
            borderWidth: 2
          }
        ]
      };
    },
    createCiroSiparisCharts(list) {
      this.ciroOnlyChartData = this.createReportChartData(list, "Ciro", "Ciro");
      this.siparisOnlyChartData = this.createReportChartData(
        list,
        "Adet",
        "SipariÅŸ Adedi"
      );
    }
  },
  created() {
    this.tabList = Store.state.uzum.menuListForTabs;

    // vm.currentTabMarketplace = vm.tabList[0].name;
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;

    this.raporListesi();
  },
  components: {
    AgGridVue,
    "v-select": vSelect,
    Datepicker,
    BFormDatepicker,
    ChartjsComponentDoughnutChart
  }
};
</script>

<style scoped>
.quick-date-range-buttons {
  display: grid;
  grid-template-columns: repeat(4, minmax(76px, 1fr));
  gap: 6px;
}

@media (max-width: 768px) {
  .quick-date-range-buttons {
    grid-template-columns: repeat(2, minmax(76px, 1fr));
  }
}
</style>
